import { Link } from 'react-router-dom'
import '../../assets/css/footer.css'
export default function Footer() {
  return (
    <footer className="wow bounceInUp0 w-100">
      <div id="footer">
        <div className="container">
          <div className="px-md-5 p-0">
            <div className="footer row px-md-5 m-0">
              <div className="col-md-4 col-12 footer-about-us d-flex">
                <div className="w-100 footer-aboutus text-start">
                  <h2 className='text-start'>About Us</h2>
                  <p>We have vast experience in the<br></br> creative industry, producing exciting<br></br> experiences for brands that
                    are<br></br> as smart, as they are effective.</p>
                </div>
              </div>
              <div className="col-md-4 footer-link-wrap row m-0">
                <div className="col-md-6 col-xs-6 col-6 float-left">
                  <div className="footer-link">
                    <h2>Quick Link</h2>
                    <ul>
                      <li><Link to="/contact">Contact</Link></li>
                      <li><Link to="/portfolio">Portfolio</Link></li>
                    </ul>
                  </div>
                </div>
                <div className="col-md-6 col-xs-6 col-6  float-left">
                  <div className="footer-link">
                    <h2>Know Us</h2>
                    <ul>
                      <li><Link to="/aboutus">About Us</Link></li>
                      <li><Link to="/contact">Hiring</Link></li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-md-4 col-12 footer-address-contact float-left">
                <div className="w-100 footer-address text-start">
                  <h2>Address</h2>
                  <ul>
                    <li>
                      {/* <span>
                          <xml version="1.0" encoding="iso-8859-1"/>
                          <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewbox="0 0 384 384" style="enable-background:new 0 0 384 384;">
                            <g>
                              <g>
                                <path d="M353.188,252.052c-23.51,0-46.594-3.677-68.469-10.906c-10.719-3.656-23.896-0.302-30.438,6.417l-43.177,32.594
                        c-50.073-26.729-80.917-57.563-107.281-107.26l31.635-42.052c8.219-8.208,11.167-20.198,7.635-31.448
                        c-7.26-21.99-10.948-45.063-10.948-68.583C132.146,13.823,118.323,0,101.333,0H30.813C13.823,0,0,13.823,0,30.813
                        C0,225.563,158.438,384,353.188,384c16.99,0,30.813-13.823,30.813-30.813v-70.323C384,265.875,370.177,252.052,353.188,252.052z"></path>
                              </g>
                            </g>
                          </svg>
                        </span>(+91) 8200755935 */}
                      (+91) 6353998044
                    </li>
                    <li>
                      {/* <span>
                          <xml version="1.0" encoding="iso-8859-1"/>
                          
                          <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"  x="0px" y="0px" viewbox="0 0 230.17 230.17" style="enable-background:new 0 0 230.17 230.17;">
                            <g>
                              <path d="M230,49.585c0-0.263,0.181-0.519,0.169-0.779l-70.24,67.68l70.156,65.518c0.041-0.468-0.085-0.94-0.085-1.418V49.585z"></path>
                              <path d="M149.207,126.901l-28.674,27.588c-1.451,1.396-3.325,2.096-5.2,2.096c-1.836,0-3.672-0.67-5.113-2.013l-28.596-26.647
                      L11.01,195.989c1.717,0.617,3.56,1.096,5.49,1.096h197.667c2.866,0,5.554-0.873,7.891-2.175L149.207,126.901z"></path>
                              <path d="M115.251,138.757L222.447,35.496c-2.427-1.443-5.252-2.411-8.28-2.411H16.5c-3.943,0-7.556,1.531-10.37,3.866
                      L115.251,138.757z"></path>
                              <path d="M0,52.1v128.484c0,1.475,0.339,2.897,0.707,4.256l69.738-67.156L0,52.1z"></path>
                            </g>
                          </svg>
                        </span> */}
                      {/* <a href="mailto:support@nslab.in" target='_blank' className="__cf_email__" > */}
                      srpinfotech777@gmail.com
                      {/* <a/> */}
                    </li>
                    <li>
                      {/* <span>
                          <svg id="Layer_1" height="512" viewbox="0 0 24 24" width="512" xmlns="http://www.w3.org/2000/svg" data-name="Layer 1">
                            <path d="m12 1a7.008 7.008 0 0 0 -7 7c0 5.243 5.916 14.177 6.168 14.555a1 1 0 0 0 1.664 0c.252-.378 6.168-9.312 6.168-14.555a7.008 7.008 0 0 0 -7-7zm0 10a3 3 0 1 1 3-3 3 3 0 0 1 -3 3z"></path>
                          </svg>
                        </span> */}
                      <p>106 - 108, Sahajanand Complex Nr.SMVS Temple BRTS Simada Naka, Varachha Surat, Gujarat 395006</p>
                    </li>
                  </ul>
                </div>
              </div>

            </div>
          </div>
        </div>
        <div className="footer-bottom text-center">
          <p>Copyright &copy; 2023 SRP Infotech. All Rights Reserved.</p>
        </div>
      </div>
    </footer>
  )
}